import { DashboardAnalyticsModel, DashboardAnalyticsDefaultValues } from './dashboard-analytics-model';

export interface DashboardModel {
    invitationCounterVisible: boolean;
    invitationsNotAcceptedCount: number;
    invitationsExpiringCount: number;
    invitationsExpiredCount: number;
    showCourseExtractButton: boolean;
    showParticipantExtractButton: boolean;
    analyticsVisible: boolean;
    bbAdminDashboardVisible: boolean;
    dashboardRoleLabel: string;
    invitationScopeLabel: string;
    showMetricsSection: boolean;
    showInvitationSection: boolean;
    showParticipantGrowthSection: boolean;
    analytics: DashboardAnalyticsModel;
}

export function DashboardModelDefaultValues(): DashboardModel {
    return {
        invitationCounterVisible: false,
        invitationsNotAcceptedCount: 0,
        invitationsExpiringCount: 0,
        invitationsExpiredCount: 0,
        showCourseExtractButton: false,
        showParticipantExtractButton: false,
        analyticsVisible: false,
        bbAdminDashboardVisible: false,
        dashboardRoleLabel: '',
        invitationScopeLabel: '',
        showMetricsSection: false,
        showInvitationSection: false,
        showParticipantGrowthSection: false,
        analytics: DashboardAnalyticsDefaultValues()
    };
}
